/**
 * 文案
 */

import axios from '@/utils/request'

export default {
  /* 文章 */
  getArticleList: (data) => axios({ url: '/api/product/essay/list', method: 'POST', data }), // 文章列表
  addArticle: (data) => axios({ url: '/api/product/essay/add', method: 'POST', data }), // 添加文章
  getArticleDetailsById: (id, params) => axios({ url: `/api/product/essay/get/${id}`, method: 'GET', params }), // 编辑文章
  updateArticle: (data) => axios({ url: '/api/product/essay/update', method: 'PUT', data }), // 修改文章
  deleteArticleById: (id, data) => axios({ url: `/api/product/essay/delete/${id}`, method: 'DELETE', data }), // 删除文章

  /* 分类 */
  getClassificationList: (data) => axios({ url: '/api/product/essay/classification/list', method: 'POST', data }), // 分类列表
  addClassification: (data) => axios({ url: '/api/product/essay/classification/add', method: 'POST', data }), // 新增分类
  getClassificationById: (id, params) => axios({ url: `/api/product/essay/classification/get/${id}`, method: 'GET', params }), // 编辑分类
  updateClassification: (data) => axios({ url: '/api/product/essay/classification/update', method: 'PUT', data }), // 修改分类
  deleteClassification: (id, data) => axios({ url: `/api/product/essay/classification/delete/${id}`, method: 'DELETE', data }), // 删除分类

  /* 标签 */
  getLabelList: (data) => axios({ url: '/api/product/essay/label/list', method: 'POST', data }), // 标签列表
  addLabel: (data) => axios({ url: '/api/product/essay/label/add', method: 'POST', data }), // 新增标签
  getLabelById: (id, params) => axios({ url: `/api/product/essay/label/get/${id}`, method: 'GET', params }), // 编辑标签
  updateLabel: (data) => axios({ url: '/api/product/essay/label/update', method: 'PUT', data }), // 修改标签
  deleteLabel: (id, data) => axios({ url: `/api/product/essay/label/delete/${id}`, method: 'DELETE', data }) // 删除标签
}
